var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.loading,"z-index":"9999"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }